import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const DeliveryPage = lazy(() => import('~/features/content-enrichment/pages/delivery-page'));

export const Route = createFileRoute(
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/delivery',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <DeliveryPage />
    </Suspense>
  ),
});
